<script setup>

import {computed, onMounted, ref, toRef, watch} from "vue";
import $ from "jquery";
import {useFolderStore, useLanguageStore} from "@/pinia";

const folderStore = useFolderStore();
const props = defineProps(['isMoveModal', 'currentFolder'])
const emits = defineEmits(['set_isMoveModal', 'moveItems'])
const selectFolder = ref();
const searchFolderName = ref();
const currFolderInfo = computed(()=> folderStore.getOneFolder(props.currentFolder));
const languageStore = useLanguageStore();

const cardSelect = ()=>{
  const treeContainer = $("#modalTreeContainer");
  treeContainer.jstree(true).deselect_all();
  treeContainer.jstree(true).select_node(`folder-${currFolderInfo.value.folderId}`);
}
const close = ()=>{
  selectFolder.value=null;
  emits('set_isMoveModal', false);
}
const move = ()=>{
  if(selectFolder.value){
    emits('moveItems', selectFolder.value.folderId);
    close();
  }else{
    return
  }

}

const creatTree = async ()=>{
  const treeData = await folderStore.getTree();
  const treeContainer = $("#modalTreeContainer");
  if(treeContainer.jstree(true)) {
    treeContainer.jstree('destroy');
  }
  await treeContainer
      .on('ready.jstree', function (e, data) {

      })
      .on("select_node.jstree", (e,data)=>{
        let id =folderStore.computedId(data.node.id);
        if(id != currFolderInfo.value.folderId){
          selectFolder.value = folderStore.getOneFolder(id);
        }else{
          selectFolder.value = null;
        }
      })
      .jstree({
        core: {
          data: treeData
        },
        plugins: ['search']
      },)
}
const search = ()=>{
  const treeContainer = $("#modalTreeContainer");
  treeContainer.jstree(true).search(searchFolderName.value)
}
onMounted(()=>{
  creatTree()
})
watch(()=>props.isMoveModal, ()=>{
  if(props.isMoveModal){
    creatTree();
  }
})
</script>

<template>

  <v-dialog
      :model-value="isMoveModal"
      @update:modelValue="close"
      width="auto"
  >
      <v-card
          :title="languageStore.get('move')"
          width="400"
          height="600"
          :subtitle="languageStore.get('selectFolderToMove')"
      >
        <v-card-text>
          <v-row
              class="moveNavArea"
          >
            <v-col cols="5">
              <v-card
                  height="50"
                  hover
                  class="d-flex justify-content-center align-items-center"
                  @click="cardSelect"
              >
                {{currFolderInfo.folderName}}
              </v-card>
            </v-col>
            <v-col>
              <v-icon>mdi-arrow-right</v-icon>
            </v-col>
            <v-col cols="5">
              <v-card v-if="selectFolder"
                      color="#D4F2FF"
                      height="50"
                      hover
                      class="d-flex justify-content-center align-items-center"
              >
                {{selectFolder.folderName}}
              </v-card>
            </v-col>
          </v-row>

          <v-text-field
              v-model="searchFolderName"
              :label="languageStore.get('searchFolder')"
              variant="outlined"
              density="compact"
              append-inner-icon="mdi-magnify"
              hide-details="auto"
              @contextmenu.prevent.stop
              @keyup="search"
              class="mb-4"
          ></v-text-field>

          <div id="modalTreeContainer" class="tree-container treeArea"></div>

        </v-card-text>
        <v-card-actions class="modal-actions">
          <v-spacer></v-spacer>
          <v-btn color="primary" variant="flat" @click="move">{{ languageStore.get('move') }}</v-btn>
          <v-btn variant="outlined" @click="close">{{ languageStore.get('close') }}</v-btn>
        </v-card-actions>
      </v-card>
  </v-dialog>
</template>

<style scoped>
/* 모달 헤더 스타일 */
:deep(.v-card-item) {
  background-color: #1A3A5C !important;
  padding: 0 !important;
}

:deep(.v-card-title) {
  background-color: #1A3A5C !important;
  color: #FFFFFF !important;
  padding: 16px 24px 8px !important;
  font-weight: 600 !important;
  font-size: 18px !important;
}

:deep(.v-card-subtitle) {
  padding: 0 24px 16px !important;
  background-color: #1A3A5C !important;
  color: rgba(255, 255, 255, 0.8) !important;
  opacity: 1 !important;
}

/* 모달 바디 - Vuetify 기본 padding 제거 */
:deep(.v-card-text) {
  padding: 24px !important;
}

/* 모달 액션 - Vuetify 기본 padding 제거 */
:deep(.v-card-actions.modal-actions) {
  padding: 16px 24px !important;
  border-top: 1px solid #DEE2E6;
  gap: 8px;
}

/* v-card-text 내 입력 필드 간격 */
.v-card-text :deep(.v-input) {
  margin-bottom: 16px;
}
</style>

<style>
.tree-container {
  padding: 10px;
  font: 0.8rem/1rem "Noto Sans KR";
  color: #333D54;
  height: calc(100% - 12rem);
  overflow-x: auto;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #accdf2 transparent;
  height: 280px;
}
.tree-container::-webkit-scrollbar {
  width: 5%;
}
.tree-container::-webkit-scrollbar-thumb {
  height: 5%; /* 스크롤바의 길이 */
  background: #accdf2; /* 스크롤바의 색상 */
  border-radius: 10px;
}
.tree-container::-webkit-scrollbar-track {
  background: transparent; /*스크롤바 뒷 배경 색상*/
}
.tree-container .jstree-container-ul .jstree-children {
  padding-top: 2.0rem;
  margin-left: 2rem;
}
.tree-container .jstree-container-ul .jstree-node {
  padding: 0;
  min-height: 2.0rem;
  margin-left: 0;
  min-width: auto;
  position: relative;
  cursor: pointer;
  background-image:none;
}
.tree-container .jstree-container-ul .jstree-node .jstree-anchor {
  height: 1.5rem;
  width: inherit;
  line-height: 1.5rem;
  position: absolute;
  left: 1.8rem;
  padding: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  box-shadow: none !important;
  border-radius: 5rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.jstree-default .jstree-clicked > .jstree-anchor {
  z-index: -99; /* 배경색을 텍스트 뒤로 보냄 */
}

.jstree-default .jstree-anchor:hover, .jstree-default .jstree-anchor:focus {
  box-shadow: none !important;
  background-color: #C0E1FF;
  left: 2rem;
  content: "";
  display: block;
  height: 1.5rem;
}
.tree-container .jstree-container-ul .jstree-node.jstree-leaf > .jstree-icon.jstree-ocl {
  display: none;
}
.tree-container .jstree-container-ul .jstree-node > .jstree-icon.jstree-ocl {
  background: center/contain no-repeat url("/src/assets/icon_20_folderArrow.svg");
  width: 1.5rem;
  height: 1.5rem;
  transition: all 0.2s;
  position: absolute;
  top: 0.0rem;
  left: 0.5rem;
  transform-origin: center;
}
.tree-container .jstree-container-ul .jstree-node.jstree-closed > .jstree-icon.jstree-ocl {
  transform: rotate(0);
}
.tree-container .jstree-container-ul .jstree-node.jstree-open > .jstree-icon.jstree-ocl {
  transform: rotate(90deg);
}
.tree-container .jstree-container-ul .jstree-node .jstree-anchor .jstree-themeicon {
  background: center/contain no-repeat url("/src/assets/icon_20_folder.svg");
  min-width: 1.5rem;
  min-height: 1.5rem;
  margin-right: 0.5rem;
}
.treeArea{
  border: 1px solid #C7C7C7;
}
.moveNavArea{
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>